// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c8d6b845","879":"1650cf2a"}[chunkId] + ".chunk.js";
};